export const maine = {
  "23000": "Maine",
  "23001": "Androscoggin County",
  "23003": "Aroostook County",
  "23005": "Cumberland County",
  "23007": "Franklin County",
  "23009": "Hancock County",
  "23011": "Kennebec County",
  "23013": "Knox County",
  "23015": "Lincoln County",
  "23017": "Oxford County",
  "23019": "Penobscot County",
  "23021": "Piscataquis County",
  "23023": "Sagadahoc County",
  "23025": "Somerset County",
  "23027": "Waldo County",
  "23029": "Washington County",
  "23031": "York County",
};
